// components/AddReminder.jsx
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';

const AddReminder = ({ individualId, API, onClose }) => {
  const [reminderText, setReminderText] = useState('');
  const [reminderDate, setReminderDate] = useState(new Date());
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await API.post('/api/reminders', {
        text: reminderText,
        reminderDate,
        individualId
      });

      toast.success('Rappel créé avec succès');
      onClose();
    } catch (error) {
      toast.error('Erreur lors de la création du rappel');
      console.error('Error creating reminder:', error);
    }

    setIsSubmitting(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96">
        <h2 className="text-xl font-semibold mb-4">Ajouter une tâche</h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">
              Description
            </label>
            <textarea
              value={reminderText}
              onChange={(e) => setReminderText(e.target.value)}
              className="w-full p-2 border rounded"
              rows="4"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Date de rappel
            </label>
            <DatePicker
              selected={reminderDate}
              onChange={date => setReminderDate(date)}
              className="w-full p-2 border rounded"
              minDate={new Date()}
              dateFormat="dd/MM/yyyy"
            />
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded hover:bg-gray-100"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 disabled:opacity-50"
            >
              {isSubmitting ? 'Creation...' : 'Créer la tâche'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddReminder;